/**
 * Enum for paste options
 */
// eslint-disable-next-line etc/no-const-enum
export var PasteType;
(function (PasteType) {
    /**
     * Default paste behavior
     */
    PasteType[PasteType["Normal"] = 0] = "Normal";
    /**
     * Paste only the plain text
     */
    PasteType[PasteType["AsPlainText"] = 1] = "AsPlainText";
    /**
     * Apply the current style to pasted content
     */
    PasteType[PasteType["MergeFormat"] = 2] = "MergeFormat";
    /**
     * If there is a image uri in the clipboard, paste the content as image element
     */
    PasteType[PasteType["AsImage"] = 3] = "AsImage";
})(PasteType || (PasteType = {}));
//# sourceMappingURL=PasteType.js.map